// extracted by mini-css-extract-plugin
export default {"root":"DumbbellSizes_root__Sd3lC","root__item":"DumbbellSizes_root__item__NCRMn"};